module.exports = __webpack_public_path__ + "static/media/shape.22160c8f.svg";